"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurIdentityAndStory() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const tenets = [{
    index: "01",
    declaration: "Clarity transforms information into confident decisions."
  }, {
    index: "02",
    declaration: "Automation reduces repetitive work and human error."
  }, {
    index: "03",
    declaration: "Every solution should fit the way the business operates."
  }, {
    index: "04",
    declaration: "Accuracy, security, and confidentiality build lasting trust."
  }];
  return <section data-section-id="2008" id="our-identity-and-story" className="text-foreground py-32 md:py-44 px-6 md:px-12 lg:px-16 overflow-hidden dark bg-accent">
      <div className="max-w-[1480px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {}
          <div ref={leftRef} className={`lg:col-span-6 relative transition-all duration-700 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            {}
            <div aria-hidden="true" className="pointer-events-none absolute -top-8 -left-4 select-none font-sans font-black leading-none" style={{
            fontSize: "clamp(12rem, 22vw, 22rem)",
            color: "transparent",
            WebkitTextStroke: "1px hsl(215 15% 88%)",
            opacity: 0.1,
            letterSpacing: "-0.04em"
          }}>
              00
            </div>

            {}
            <div className="relative font-mono uppercase mb-10" style={{
            letterSpacing: "0.18em",
            fontSize: "clamp(0.6875rem, 0.8vw, 0.8125rem)"
          }}>
              
            </div>

            {}
            <h1 className="relative font-default font-bold" style={{
            fontSize: "clamp(3.25rem, 8vw, 7.5rem)",
            lineHeight: 0.88,
            letterSpacing: "-0.04em"
          }}>We turn complex data into&nbsp; <span className="font-serif italic font-normal" data-ast-id="f:/src/pages/AboutUs/sections/OurIdentityAndStory.tsx|sig:j27u67" data-ast-start="2237" data-ast-end="2297" contenteditable="false" style={{}}>clear</span> action.</h1>

            {}
            <div className="relative mt-12 mb-10 flex items-center">
              <div className="flex-1 h-px bg-border" />
              <div className="w-1.5 h-1.5 ml-0 bg-secondary" />
            </div>

            {}
            <p className="font-default relative" style={{
            fontSize: "clamp(1.0625rem, 1.25vw, 1.25rem)",
            lineHeight: 1.55
          }}>Infinix Solutions helps businesses simplify complex data, automate repetitive processes, and create clear, reliable reporting systems.<div><br /></div><div>We combine data analytics, automation, and practical business knowledge to reduce manual work, improve accuracy, and give decision-makers information they can trust.</div><div><br /></div><div>We do this because businesses should not lose time struggling with disconnected systems, repetitive spreadsheets, and unclear reports. Our purpose is to create practical solutions that make work easier, reporting stronger, and decisions more confident.</div></p>

            {}
            <div className="relative mt-14">
              {tenets.map((tenet, i) => <div key={tenet.index} data-index={i} className={`transition-all duration-700 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
              transitionDelay: leftVisible ? `${200 + i * 80}ms` : "0ms"
            }}>
                  <div className="flex items-center pt-5 pb-5">
                    <div className="font-mono shrink-0 w-16 md:w-20 text-secondary" style={{
                  fontSize: "clamp(0.6875rem, 0.8vw, 0.8125rem)",
                  letterSpacing: "0.18em"
                }}>
                      {tenet.index} —
                    </div>
                    <div className="font-default font-semibold" style={{
                  fontSize: "clamp(1.0625rem, 1.4vw, 1.375rem)",
                  lineHeight: 1.3
                }}>
                      {tenet.declaration}
                    </div>
                  </div>
                  {}
                  <div className="flex items-center">
                    <div className="flex-1 h-px bg-border" />
                    <div className="w-1.5 h-1.5 bg-secondary" />
                  </div>
                </div>)}
            </div>
          </div>

          {}
          <div ref={rightRef} className={`lg:col-span-6 transition-all duration-700 ease-out ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          transitionDelay: rightVisible ? "150ms" : "0ms"
        }}>
            <div className="relative w-full h-full min-h-[480px] lg:min-h-[720px]">
              {}
              <div className="relative w-full h-full aspect-[4/5] lg:aspect-auto lg:absolute lg:inset-0 overflow-hidden rounded-lg shadow-lg">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705424/img/data_architecture_dashboard.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705424/img/data_architecture_dashboard.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705424/img/data_architecture_dashboard.webp-wvc-sizes" alt="Advanced data analytics dashboard interface showing network nodes" loading="lazy" decoding="async" className="w-full h-full object-cover" />

                {}
                <div className="absolute top-4 left-4 w-3 h-3 pointer-events-none">
                  <div className="absolute top-0 left-0 w-full h-px bg-secondary" />
                  <div className="absolute top-0 left-0 h-full w-px bg-secondary" />
                </div>
                {}
                <div className="absolute top-4 right-4 w-3 h-3 pointer-events-none">
                  <div className="absolute top-0 right-0 w-full h-px bg-secondary" />
                  <div className="absolute top-0 right-0 h-full w-px bg-secondary" />
                </div>
                {}
                <div className="absolute bottom-4 left-4 w-3 h-3 pointer-events-none">
                  <div className="absolute bottom-0 left-0 w-full h-px bg-secondary" />
                  <div className="absolute bottom-0 left-0 h-full w-px bg-secondary" />
                </div>
                {}
                <div className="absolute bottom-4 right-4 w-3 h-3 pointer-events-none">
                  <div className="absolute bottom-0 right-0 w-full h-px bg-secondary" />
                  <div className="absolute bottom-0 right-0 h-full w-px bg-secondary" />
                </div>

                {}
                <div className="absolute bottom-0 left-0 right-0 px-6 py-4 font-mono uppercase bg-background/85 backdrop-blur-sm border-t border-secondary/40" style={{
                color: "var(--foreground)",
                fontSize: "0.75rem",
                letterSpacing: "0.18em"
              }}>
                  FIG. 01 — ANALYTICS / ARCHITECTURE / SYSTEM
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}